module.exports = __webpack_public_path__ + "img/a11y-large-text-1_jp.2ad0838.jpg";